// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"SbuEditPopup_pageStyle__26N7U","dialogCard":"SbuEditPopup_dialogCard__2OFmT"};